<template>
    <div class="container mescroll-touch">
        <div class="topdh" @click="back"><img src="../../assets/images/bjback.png" class="homeimg" />首页&nbsp;>&nbsp;{{
            Name }}
        </div>
        <!-- <img src="../../assets/images/topguanggao.png" class="guanggaoimg" /> -->
        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/jiaotongicon.png" class="modeltitleimg" />
                    <div class="modeltitletext">会议地点</div>
                </div>
            </div>
            <div class="neirong">
                <div class="name">{{ totalinfo.MeetingAddress }}</div>
                <!-- <div class="newtext">点击以下地图即可查询交通路线</div> -->
            </div>
            <!-- <img src="../../assets/images/ccdspos.png" alt="" class="posimg"> -->
            <div class="mapview" @click="goapp()">
                <el-amap class="amap-box" :vid="'amap-vue'" @init="handleMapInit" :zoom="zoom" :center="position">
                    <el-amap-marker :vid="'marker'" :position="position" :events="events" ref="map"></el-amap-marker>
                </el-amap>
            </div>
        </div>

        <div class="model" v-if="totalinfo.HotelInfo">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/jiaotongicon.png" class="modeltitleimg" />
                    <div class="modeltitletext">住宿信息</div>
                </div>
            </div>
            <div class="neirong" v-html="totalinfo.HotelInfo">
            </div>
        </div>

        <div class="model" v-if="totalinfo.TrafficInfo">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/jiaotongicon.png" class="modeltitleimg" />
                    <div class="modeltitletext">公共交通</div>
                </div>
            </div>
            <div class="neirong" v-html="totalinfo.TrafficInfo">

            </div>
        </div>
        <div class="backbtn" @click="back()">
            <img src="../../assets/images/backicon.png" alt="">
        </div>
    </div>
</template>

<script>
import mixin from '../../common/mixin/mixins'
export default {
    name: 'custommap',
    data() {
        return {
            map: null,
            zoom: 17,
            position1: '',
            position2: '',
            position: [this.$route.query.p1, this.$route.query.p2],
            totalinfo: '',
            events: {},
            Name: this.$route.query.Name
        }
    },
    mixins: [mixin],
    created() {
        this.getinfo();
        this.getmod();
        document.title = this.$route.query.Title;
    },
    mounted() {
        this.initDrag();
    },
    methods: {
        getmod() {
            let that = this
            this.$axios
                .get("/api/api/web/Activity/GetModel?id=" + this.$route.query.ActivityId)
                .then((res) => {
                    that.meetinginfo = res.Data
                    this.initzqShare(that.meetinginfo.ForwardMainTitle, this.$route.query.Name, that.meetinginfo.ForwardPic);
                });
        },
        getinfo() {
            let that = this;
            this.$axios.get('/api/api/web/Activity/GetModuleModel?id=' + this.$route.query.Id).then(res => {
                if (res.RetCode == "10000") {
                    console.log(res.Data)
                    that.totalinfo = res.Data
                }
            });
        },
        goapp(lat, lng, name) {
            let that = this
            window.location.href = "https://uri.amap.com/marker?position=" + this.$route.query.p1 + ',' + this.$route.query.p2
            // let isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
            // let scheme = isIOS ? 'iosamap://' : 'androidamap://';
            // let url = `${scheme}navi?sourceApplication=web&poiname=${encodeURIComponent(name)}&lat=${lat}&lon=${lng}&dev=0`;

            // window.location.href = url;
            // setTimeout(() => {
            //     if (!document.hidden) {
            //         window.location.href = 'https://www.amap.com/download';
            //     }
            // }, 2000);
        },
        back() {
            this.$router.replace({
                path: "custom",
                query: {
                    Id: this.$route.query.ActivityId,
                },
            });
        },
        initDrag() {
            const btn = document.querySelector('.backbtn');
            if (!btn) return;

            // 触摸开始（移动端）
            btn.addEventListener('touchstart', (e) => {
                this.isDragging = true;
                // 获取初始触摸位置
                this.startX = e.touches[0].clientX;
                this.startY = e.touches[0].clientY;
                // 获取按钮当前位置
                const rect = btn.getBoundingClientRect();
                this.btnX = rect.left;
                this.btnY = rect.top;
                // 阻止默认行为
                // e.preventDefault();
            });

            // 触摸移动（移动端）
            btn.addEventListener('touchmove', (e) => {
                if (!this.isDragging) return;
                // 计算移动距离
                const moveX = e.touches[0].clientX - this.startX;
                const moveY = e.touches[0].clientY - this.startY;
                // 设置按钮新位置
                btn.style.left = `${this.btnX + moveX}px`;
                btn.style.top = `${this.btnY + moveY}px`;
                // 清除原有right/transform
                btn.style.right = 'auto';
                btn.style.transform = 'none';
                e.preventDefault();
            });

            // 触摸结束（移动端）
            btn.addEventListener('touchend', () => {
                this.isDragging = false;
            });

            // 兼容PC端鼠标操作
            btn.addEventListener('mousedown', (e) => {
                this.isDragging = true;
                this.startX = e.clientX;
                this.startY = e.clientY;
                const rect = btn.getBoundingClientRect();
                this.btnX = rect.left;
                this.btnY = rect.top;
                e.preventDefault();
            });

            document.addEventListener('mousemove', (e) => {
                if (!this.isDragging) return;
                const moveX = e.clientX - this.startX;
                const moveY = e.clientY - this.startY;
                btn.style.left = `${this.btnX + moveX}px`;
                btn.style.top = `${this.btnY + moveY}px`;
                btn.style.right = 'auto';
                btn.style.transform = 'none';
            });

            document.addEventListener('mouseup', () => {
                this.isDragging = false;
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.container {
    height: 100%;
    width: 100%;
    // background: rgb(228, 236, 255);
}

.img {
    display: block;
    width: 100%;
    margin-bottom: .2rem
}

.zuzhititleimg {
    display: block;
    width: 55%;
    margin: auto;
    margin-bottom: .2rem
}

.zuzhititleimg1 {
    display: block;
    width: 55%;
    margin: .5rem auto .2rem auto;
}

.guanggaoimg {
    display: block;
    width: 92%;
    margin: 0.5rem auto;
}

.modelline {
    border-bottom: 1px solid rgb(0, 53, 133);
    border-bottom-left-radius: 50rem;
}

.modeltitle {
    background: rgb(0, 53, 133);
    width: 37%;
    display: flex;
    flex-direction: row;
    padding: 0.1rem;
    border-radius: 30px 50px 0px 30px;
}

.modeltitle1 {
    background: rgb(0, 53, 133);
    width: 45%;
    display: flex;
    flex-direction: row;
    padding: 0.1rem;
    border-radius: 30px 50px 0px 30px;
}

.modeltitleimg {
    display: block;
    width: 15%;
    background: #fff;
    border-radius: 50rem;
    width: 0.5rem;
    height: 0.5rem;
    box-sizing: border-box;
    padding: 0.05rem 0.08rem;
}

.modeltitletext {
    margin-left: 0.2rem;
    color: #fff;
    font-weight: bold;
    // font-size: 16px;
}

.model {
    width: 92%;
    margin: auto;
    margin-top: 0.5rem;
}

.model1 {
    width: 92%;
    margin: auto;
    margin-top: 0.5rem;
    padding-bottom: 1rem;
}

.center {
    text-align: center;
}

.preple {
    color: rgb(0, 53, 133);
}

.neirong {
    margin-top: .3rem
}

.ziti {
    font-size: .37rem;
}

.neirong {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 95%;
    margin: auto;
    margin-top: 0.3rem;
}

.name {
    width: 100%;
    // text-align: center;
    font-size: .37rem;
    margin: 0.08rem 0;
    // margin: 0.1rem 0;
}

.name1 {
    width: 50%;
    text-align: right;
    font-size: .37rem;
    // margin: 0.1rem 0;
}

.perplebold {
    color: rgb(0, 53, 133);
    font-weight: bold;
}

.wait {
    text-align: center;
    color: rgb(0, 53, 133);
    font-weight: bold;
    font-size: .55rem;
    margin-top: 20%;
}

.mapview {
    width: 95%;
    margin: auto;
    height: 5.5rem;
    margin-top: 0.3rem;
}

.darkperplebold {
    color: rgb(0, 53, 133);
    // font-weight: bold;
}

.newtext {
    margin-top: 0.5rem;
    font-weight: bold;
}

.small {
    font-size: .3rem;
}

.posimg {
    width: 100%;
    margin-top: 0.5rem;
}

.topdh {
    font-family: cursive;
    font-weight: bold;
    background: #003583;
    color: #fff;
    padding: 0.3rem;
}

.homeimg {
    width: 5%;
    display: inline-block;
    vertical-align: text-bottom;
    margin-right: 0.1rem;
}

.backbtn {
    width: 13%;
    position: fixed;
    right: 0;
    top: 50%;
    opacity: .8;
    transform: translateY(-50%);
    z-index: 99999;
    /* 新增拖动相关样式 */
    touch-action: none;
    /* 禁用浏览器默认触摸行为 */
    user-select: none;
    /* 防止拖动时选中文字 */
    -webkit-user-drag: element;
    /* 开启移动端拖动 */
    cursor: move;
    /* 鼠标指针提示可拖动 */
    transition: transform 0.1s ease;
    /* 拖动过渡更顺滑 */
}

.backbtn:active {
    opacity: 1;
    /* 拖动时提高透明度，增强反馈 */
    transform: translateY(-50%) scale(1.05);
    /* 拖动时轻微放大，提升体验 */
}

.backbtn img {
    width: 100%;
    pointer-events: none;
    /* 让拖动事件穿透到父元素 */
}
</style>